import { Component } from '@angular/core';

@Component({
    selector: 'app-community',
    templateUrl: './community.component.html',
    styleUrls: ['./community.component.scss'],
    standalone: false
})
export class CommunityComponent {

}
